module.exports = __webpack_public_path__ + "static/img/person_5.f199c2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/person/person_5.jpg
// module id = mgaO
// module chunks = 1